var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.221 1.123a4 4 0 015.656 5.656l-.01.01-3.2 3.2a4 4 0 01-5.656 0 .8.8 0 011.132-1.132 2.4 2.4 0 003.393 0l3.195-3.194a2.4 2.4 0 00-3.394-3.394l-.874.875A.8.8 0 118.33 2.013l.88-.88.01-.01zm-4.81 4.81a4 4 0 015.656 0 .8.8 0 11-1.13 1.131 2.4 2.4 0 00-3.394 0l-3.2 3.2-.01.01a2.4 2.4 0 103.393 3.393l.01-.01.882-.88a.8.8 0 011.13 1.131l-.876.876a4 4 0 11-5.656-5.656L4.41 5.933z"}));
}

Link.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = Link;

Link.default = Link;
